import { CONSTANT_TEXTS } from '@gp/constants/const';

/**
 * 配置信息
 */
export const STAGE_OPT = [
  {
    value: 'live',
    text: 'Live',
  },
  {
    value: 'development',
    text: 'Development',
  },
  {
    value: 'legacy',
    text: 'Legacy',
  },
  {
    value: 'pre-planned',
    text: 'Pre-Planned',
  },
  {
    value: 'planned',
    text: 'Planned',
  },
  {
    value: 'canceled',
    text: CONSTANT_TEXTS.CANCELED,
  },
  {
    value: 'no maintenance',
    text: 'No Maintenance',
  },
];
